import { capitalizeFirstLetter } from './capitalizeFirstLetter';
import { formatDateTimeZone } from './formatDateTimeZone';

/* The endpoint sends "-" for a missing violation date, which moment parses as an invalid date and
   formats as the literal string "Invalid date". Kept local rather than changed in
   formatDateTimeZone, which the whole app uses. */
const formatViolationDate = (value, timeZone) => {
  const formatted = formatDateTimeZone(value, timeZone, 'L');
  return !formatted || formatted === 'Invalid date' ? null : formatted;
};

export const parseRevisitData = ({ data }, timeZone) =>
  data.map((item) => ({
    ...item,
    attributes: {
      id: item.id,
      ...item.attributes,
      date: formatViolationDate(item.attributes?.violation_date, timeZone),
      name: capitalizeFirstLetter(item.attributes?.name),
    },
  }));
